import { BackgroundStyle, BigHeading, FlexContainer, ListContainer, SearchingBoxContainer, LongBlueButton } from "../assets/style";
import { TableHeader } from "../components/RecordTable";
import { useEffect, useState } from "react";
import SearchInput from "../components/SearchInput";
import SearchBox from "../components/SearchBox";
import { useLocation, useNavigate } from "react-router-dom";
import MainContent from '../components/MainContent';
import { userPageName } from "../components/PageName";
import { useLazyGetWorkerDropdownListQuery, } from "../features/worker/workerSlice";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { WorkerAsDropdownListItemModel } from "../models/WorkerModel";
import SearchDropDownList from "../components/SearchDropDownList";
import RecordTableV2 from "../components/RecordTableV2";
import { RecordModel } from "../models/RecordModel";
import { useTranslation } from "react-i18next";
import { useLazyGetRegisterRoleDropDownListQuery, useLazyGetRoleDropDownListQuery, useLazyGetUserListingQuery, useLazyGetUserRegistrationRequestListingQuery } from "../features/auth/authApiSlice";
import { useForm } from "react-hook-form";
import HookSearchInput from "../components/HookSearchInput";
import HookSearchDropDownList from "../components/HookSearchDropDownList";
import FetchingItems from "../components/FetchingItems";
import { useLazyGetCompanyDropDownListQuery } from "../features/comapny/comapnySlice";
import { Box } from "@mui/material";

const UserListPage = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation()
    const [subPage, setSubPage] = useState<"userList" | "userRegistrationList">(location.state?.subpage ?? "userList")

    const isUserList = subPage == "userList"
    const isUserRegistrationList = subPage == "userRegistrationList"

    return (
        <MainContent type={userPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <Box sx={{ display: "flex" }}>
                        <BigHeading
                            onClick={() => setSubPage("userList")}
                            sx={isUserList ? {} : { color: "lightgrey", cursor: "pointer" }}>
                            {t("User")}
                        </BigHeading>
                        <BigHeading
                            onClick={() => setSubPage("userRegistrationList")}
                            sx={isUserRegistrationList ? {} : { color: "lightgrey", cursor: "pointer" }}>
                            {t("Registration Request")}
                        </BigHeading>
                    </Box>
                    <div style={isUserList ? {} : { display: "none" }}>
                        <UserList />
                    </div>
                    <div style={isUserRegistrationList ? {} : { display: "none" }}>
                        <UserRegistrationRequestList />
                    </div>
                </ListContainer>
            </BackgroundStyle>
        </MainContent >
    )
}

const UserList = () => {
    const { t, i18n } = useTranslation();

    const { register, control, getValues } = useForm<{ name?: string, email?: string, roleId?: string, companyId?: string, isActive?: boolean }>()

    const [getUserListingQuery,] = useLazyGetUserListingQuery();
    const navigate = useNavigate();
    const columns: TableHeader[] | any = [
        { field: 'name', headerName: t('Name'), width: 200, isSortable: true },
        { field: 'email', headerName: t('Email'), width: 200, isSortable: true },
        { field: 'companyName', headerName: t('Company Name'), width: 300, isSortable: true },
        { field: 'roleName', headerName: t('Role Name'), width: 300, isSortable: false },
    ];
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getUserListingQuery(
            {
                ...getValues(),
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                userId: item.id,
                name: item.name,
                email: item.email,
                roleName: item.roleName,
                companyName: item.companyName,
            }))
        }
        // return [];
    };

    const handleTableData = async () => {
        try {
            if (localStorage.accessToken) {
                getUserListingQuery(getValues()).then(
                    (res) => {
                        if (res.status == 'fulfilled') {

                            const tableRows = res?.data.records.map((item: any) => ({
                                id: item?.id,
                                userId: item.id,
                                name: item.name,
                                email: item.email,
                                roleName: item.roleName,
                                companyName: item.companyName,
                            }))
                            setTableRows(tableRows)
                            setData(res?.data)
                        }
                    }
                )
            }
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }

    useEffect(() => {
        handleTableData()
    }, []);

    const handleRowClick = (user: any, field?: string) => {
        if (!(field != undefined && (field == 'certification' || field == '__check__'))) {
            navigate('/user-detail', { state: { userId: user.userId } });
        }
    };

    return (
        <>
            <SearchingBoxContainer>
                <SearchBox>
                    <FlexContainer>
                        <HookSearchInput title={t("Name")} register={() => register("name")} />
                        <HookSearchInput title={t("Email")} register={() => register("email")} />
                        <FetchingItems<{ id: number, name: string }[]>
                            useLazyQuery={useLazyGetRoleDropDownListQuery}
                            render={(items, isLoading) => (
                                <HookSearchDropDownList
                                    title={t("Role")}
                                    name="roleId"
                                    control={control}
                                    items={isLoading ? [] : items ?? []}
                                    addEmpty={true}
                                />
                            )}
                        />
                        <FetchingItems<{ id: number, name: string }[]>
                            useLazyQuery={useLazyGetCompanyDropDownListQuery}
                            render={(items, isLoading) => (
                                <HookSearchDropDownList
                                    title={t("Company")}
                                    name="companyId"
                                    control={control}
                                    items={isLoading ? [] : items ?? []}
                                    addEmpty={true}
                                />
                            )}
                        />
                        <HookSearchDropDownList
                            title={t("Is Active")}
                            name="isActive"
                            control={control}
                            items={[{ id: true, name: "True" }, { id: false, name: "False" }]}
                            addEmpty={true}
                        />
                    </FlexContainer>
                    <FlexContainer>
                        <LongBlueButton onClick={() => handleTableData()}>{t("Search")}</LongBlueButton>
                    </FlexContainer>
                    <FlexContainer>
                        <LongBlueButton onClick={() => { navigate('/add-user') }}>{t("Add New User")}</LongBlueButton>
                    </FlexContainer>
                </SearchBox>
            </SearchingBoxContainer>
            {/* <RecordTable getRowId={e => e.workerId} columns={columns} rows={rows} checkbox={true} onClick={handleRowClick}></RecordTable> */}
            <RecordTableV2
                columns={columns}
                rows={tableRows}
                checkbox={false}
                pages={data?.totalPages}
                totalCount={data?.totalCount}
                onClick={handleRowClick}
                updateTableRows={setTableRows}
                fetchDataForPage={fetchDataForPage}
            />
        </>
    )
}

const UserRegistrationRequestList = () => {
    const { t, i18n } = useTranslation();

    const { register, control, getValues } = useForm<{ name?: string, email?: string, roleId?: string, companyName?: string, status: string }>()

    const [getUserRegistrationRequestListingQuery,] = useLazyGetUserRegistrationRequestListingQuery();
    const navigate = useNavigate();
    const columns: TableHeader[] | any = [
        { field: 'name', headerName: t('Name'), width: 200, isSortable: true },
        { field: 'email', headerName: t('Email'), width: 200, isSortable: true },
        { field: 'companyName', headerName: t('Company Name'), width: 300, isSortable: true },
        { field: 'roleName', headerName: t('Role Name'), width: 200, isSortable: false },
        { field: 'status', headerName: t('Status'), width: 200, isSortable: false },
    ];
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getUserRegistrationRequestListingQuery(
            {
                ...getValues(),
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                userRegistrationRequestId: item.id,
                name: item.name,
                email: item.email,
                roleName: item.roleName,
                companyName: item.companyName,
                status: item.status
            }))
        }
        // return [];
    };

    const handleTableData = async () => {
        try {
            if (localStorage.accessToken) {
                getUserRegistrationRequestListingQuery(getValues()).then(
                    (res) => {
                        if (res.status == 'fulfilled') {

                            const tableRows = res?.data.records.map((item: any) => ({
                                id: item?.id,
                                userRegistrationRequestId: item.id,
                                name: item.name,
                                email: item.email,
                                roleName: item.roleName,
                                companyName: item.companyName,
                                status: item.status
                            }))
                            setTableRows(tableRows)
                            setData(res?.data)
                        }
                    }
                )
            }
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }

    useEffect(() => {
        handleTableData()
    }, []);

    const handleRowClick = (userRegistrationRequest: any, field?: string) => {
        if (!(field != undefined && (field == 'certification' || field == '__check__'))) {
            if (userRegistrationRequest.status == "Pending")
                navigate('/add-user', { state: { userRegistrationRequestId: userRegistrationRequest.userRegistrationRequestId } });
            else
                navigate('/user-registration-request-detail', { state: { userRegistrationRequestId: userRegistrationRequest.userRegistrationRequestId } });
        }
    };

    return (
        <>
            <SearchingBoxContainer>
                <SearchBox>
                    <FlexContainer>
                        <HookSearchInput title={t("Name")} register={() => register("name")} />
                        <HookSearchInput title={t("Email")} register={() => register("email")} />
                        <FetchingItems<{ id: number, name: string }[]>
                            useLazyQuery={useLazyGetRegisterRoleDropDownListQuery}
                            render={(items, isLoading) => (
                                <HookSearchDropDownList
                                    title={t("Role")}
                                    name="roleId"
                                    control={control}
                                    items={isLoading ? [] : items ?? []}
                                    addEmpty={true}
                                />
                            )}
                        />
                        <HookSearchInput title={t("Company Name")} register={() => register("companyName")} />
                        <HookSearchDropDownList
                            title={t("Status")}
                            name="status"
                            control={control}
                            items={[{ id: "Pending", name: "Pending" }, { id: "Approved", name: "Approved" }, { id: "Declined", name: "Declined" }]}
                            addEmpty={true}
                        />
                    </FlexContainer>
                    <FlexContainer>
                        <LongBlueButton onClick={() => handleTableData()}>{t("Search")}</LongBlueButton>
                    </FlexContainer>
                </SearchBox>
            </SearchingBoxContainer>
            {/* <RecordTable getRowId={e => e.workerId} columns={columns} rows={rows} checkbox={true} onClick={handleRowClick}></RecordTable> */}
            <RecordTableV2
                columns={columns}
                rows={tableRows}
                checkbox={false}
                pages={data?.totalPages}
                totalCount={data?.totalCount}
                onClick={handleRowClick}
                updateTableRows={setTableRows}
                fetchDataForPage={fetchDataForPage}
            />
        </>
    )
}

export default UserListPage;